export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/family-thumb-913f985b4973a1a1a9ed3b79fdfc6928.png";